import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { ApprovalProcessModel } from "@models/approvalProcess/approvalProcessModel"

class ApprovalProcess {
  public async create(body: any) {
    const res = await http.post("api/services/app/Approval/Create", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put("api/services/app/Approval/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Approval/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Approval/Get", {
      params: { id },
    })
    const { result } = res.data
    return ApprovalProcessModel.assign(result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Approval/GetAll", {
      params,
    })
    return res.data.result
  }
  public async getList(params: any): Promise<any> {
    const res = await http.get("api/services/app/Approval/GetList", {
      params,
    })
    return res.data.result
  }

  public async getListFlow(params: any): Promise<any> {
    const res = await http.get("api/services/app/Approval/GetListFlow", {
      params,
    })
    return res.data.result
  }

  public async sendRequest(body: any) {
    const res = await http.post("api/services/app/Approval/SendRequest", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SEND_APPROVAL_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async sendMultiRequest(body: any) {
    const res = await http.post(
      "api/services/app/Approval/SendMultiRequest",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("APPROVAL_SUCCESSFULLY")
    )
    return res.data.result
  }
}

export default new ApprovalProcess()
